import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';

const GOLD = '#C9A84C';
const BG = '#050810';
const SURFACE = '#0B1120';
const BORDER = 'rgba(255,255,255,0.07)';
const OFF_WHITE = '#A0AABB';
const RED = '#FF4444';
const GREEN = '#22C55E';

const s = {
  page: {
    background: BG,
    color: '#fff',
    fontFamily: "-apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif",
    minHeight: '100vh',
  },
  wrap: {
    maxWidth: 720,
    margin: '0 auto',
    padding: '72px 24px 80px',
  },
  badge: {
    display: 'inline-block',
    background: 'rgba(201,168,76,0.12)',
    border: '1px solid rgba(201,168,76,0.3)',
    color: GOLD,
    fontSize: 11,
    fontWeight: 700,
    letterSpacing: '0.12em',
    textTransform: 'uppercase',
    padding: '6px 14px',
    borderRadius: 20,
    marginBottom: 24,
  },
  h1: {
    fontSize: 'clamp(28px,5vw,42px)',
    fontWeight: 800,
    margin: '0 0 16px',
    lineHeight: 1.15,
  },
  sub: {
    color: OFF_WHITE,
    fontSize: 17,
    lineHeight: 1.7,
    margin: '0 0 56px',
  },
  sectionTitle: {
    fontSize: 11,
    fontWeight: 700,
    letterSpacing: '0.14em',
    textTransform: 'uppercase',
    color: OFF_WHITE,
    marginBottom: 20,
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse',
    marginBottom: 48,
  },
  thMane: {
    background: 'rgba(201,168,76,0.1)',
    color: GOLD,
    fontWeight: 700,
    fontSize: 13,
    padding: '14px 20px',
    textAlign: 'left',
    border: '1px solid rgba(201,168,76,0.2)',
    borderBottom: `2px solid ${GOLD}`,
  },
  thComp: {
    background: SURFACE,
    color: OFF_WHITE,
    fontWeight: 700,
    fontSize: 13,
    padding: '14px 20px',
    textAlign: 'left',
    border: `1px solid ${BORDER}`,
  },
  thLabel: {
    background: 'transparent',
    color: OFF_WHITE,
    fontWeight: 600,
    fontSize: 12,
    padding: '14px 0',
    textAlign: 'left',
    letterSpacing: '0.04em',
    border: 'none',
    borderBottom: `1px solid ${BORDER}`,
  },
  tdLabel: {
    color: OFF_WHITE,
    fontSize: 14,
    padding: '16px 0',
    borderBottom: `1px solid ${BORDER}`,
    fontWeight: 500,
    verticalAlign: 'top',
  },
  tdMane: {
    color: '#fff',
    fontSize: 14,
    padding: '16px 20px',
    borderBottom: '1px solid rgba(201,168,76,0.15)',
    background: 'rgba(201,168,76,0.04)',
    border: '1px solid rgba(201,168,76,0.1)',
    verticalAlign: 'top',
  },
  tdComp: {
    color: OFF_WHITE,
    fontSize: 14,
    padding: '16px 20px',
    borderBottom: `1px solid ${BORDER}`,
    background: SURFACE,
    border: `1px solid ${BORDER}`,
    verticalAlign: 'top',
  },
  callout: {
    background: 'rgba(201,168,76,0.07)',
    border: '1px solid rgba(201,168,76,0.25)',
    borderRadius: 12,
    padding: '28px 32px',
    marginBottom: 48,
  },
  calloutLabel: {
    fontSize: 11,
    fontWeight: 700,
    letterSpacing: '0.12em',
    textTransform: 'uppercase',
    color: GOLD,
    marginBottom: 12,
  },
  calloutText: {
    color: '#fff',
    fontSize: 16,
    lineHeight: 1.8,
    margin: 0,
  },
  faqItem: {
    borderBottom: `1px solid ${BORDER}`,
    paddingBottom: 28,
    marginBottom: 28,
  },
  faqQ: {
    color: '#fff',
    fontWeight: 700,
    fontSize: 15,
    marginBottom: 10,
  },
  faqA: {
    color: OFF_WHITE,
    fontSize: 15,
    lineHeight: 1.7,
    margin: 0,
  },
  cta: {
    background: 'rgba(201,168,76,0.07)',
    border: '1px solid rgba(201,168,76,0.25)',
    borderRadius: 16,
    padding: '48px 40px',
    textAlign: 'center',
    marginTop: 56,
  },
  ctaTitle: {
    fontSize: 24,
    fontWeight: 800,
    marginBottom: 12,
  },
  ctaSub: {
    color: OFF_WHITE,
    fontSize: 15,
    lineHeight: 1.6,
    marginBottom: 32,
  },
  btn: {
    display: 'inline-block',
    background: GOLD,
    color: '#000',
    fontWeight: 800,
    fontSize: 14,
    letterSpacing: '0.06em',
    textTransform: 'uppercase',
    padding: '16px 40px',
    borderRadius: 8,
    textDecoration: 'none',
  },
};

const rows = [
  {
    label: 'Monthly Price',
    mane: '$29/mo — locked forever',
    comp: <span>Free plan (limited) or $29/mo+ for Appointments<br /><span style={{ fontSize: 12, color: OFF_WHITE }}>Plus plan $69/mo for full features</span></span>,
  },
  {
    label: 'Payment Processing Fees',
    mane: <span style={{ color: GREEN }}>Standard Stripe (2.9% + 30c)</span>,
    comp: <span style={{ color: RED }}>2.6% + 10c in-person, 2.9% + 30c online<br /><span style={{ fontSize: 12 }}>Locked to Square's processor</span></span>,
  },
  {
    label: 'Commission on Bookings',
    mane: <span style={{ color: GREEN }}>0% — always</span>,
    comp: <span>No direct commission, but processing fees on every transaction</span>,
  },
  {
    label: 'Built for Beauty Pros',
    mane: <span style={{ color: GREEN }}>Yes — designed for barbers, stylists, estheticians</span>,
    comp: <span style={{ color: RED }}>No — built for restaurants, retail, general business</span>,
  },
  {
    label: 'Client Data Ownership',
    mane: <span style={{ color: GREEN }}>Yours. Export anytime.</span>,
    comp: <span style={{ color: RED }}>Tied to Square ecosystem. Limited portability.</span>,
  },
  {
    label: 'AI Re-Engagement',
    mane: <span style={{ color: GREEN }}>Included — auto win-back messages</span>,
    comp: <span style={{ color: RED }}>Not available</span>,
  },
  {
    label: 'SMS Reminders',
    mane: <span style={{ color: GREEN }}>Included</span>,
    comp: 'Available on paid plans',
  },
  {
    label: 'Beauty-Specific Features',
    mane: <span style={{ color: GREEN }}>Service menus, chair time, portfolio, intake forms</span>,
    comp: <span style={{ color: RED }}>Generic service listings — no beauty specialization</span>,
  },
  {
    label: 'Contract',
    mane: 'Month-to-month',
    comp: 'Month-to-month',
  },
];

const faqs = [
  {
    q: "Isn't Square Appointments free?",
    a: "Square's free plan gives you a basic calendar for one person. That's it. No automated reminders, no team features, no real client management. The moment you need actual business tools, you're on the $29/mo plan — and even that's limited. Their Plus plan at $69/mo is where the real features live. At that point, you're paying more than double Mane's rate for a tool that wasn't even built for your industry.",
  },
  {
    q: 'Is Square good for barbers and stylists?',
    a: "Square was built for retail stores and restaurants. Appointment booking was an afterthought they bolted on. There's no portfolio display, no beauty-specific intake forms, no understanding of how a chair rental or suite business works. It does payments well — that's Square's core business. But for everything else a beauty professional needs, you're working around a tool that wasn't designed for you.",
  },
  {
    q: "Can I switch from Square to Mane easily?",
    a: "Yes. Mane has a client import tool. Export your client list from Square, upload it to Mane, and you're live. Your booking link works immediately — share it on Instagram, your website, wherever. Most pros are fully switched in under an hour.",
  },
  {
    q: "What does Square have that Mane doesn't?",
    a: "Square has a full POS system for in-person retail, inventory management, and a hardware ecosystem (card readers, terminals, registers). If you sell physical products alongside services, Square's retail features are strong. Mane doesn't do inventory or POS — we focus entirely on booking, client management, and growing your service business.",
  },
  {
    q: "What happens to my price if Mane raises rates?",
    a: "Founding members are locked at $29/mo for life. That's in your membership agreement. When we raise prices for new members, your rate doesn't move. Ever.",
  },
];

export default function VsSquare() {
  return (
    <div style={s.page}>
      <Helmet>
        <title>Mane vs. Square Appointments — Built Different</title>
        <meta name="description" content="Square wasn't built for beauty professionals. Generic scheduling bolted onto a retail POS. Here's why barbers, stylists, and estheticians are choosing Mane instead." />
        <meta property="og:title" content="Mane vs. Square Appointments — Built Different" />
        <meta property="og:description" content="Square is a retail POS with scheduling bolted on. Mane was built from day one for beauty professionals. Here's the real comparison." />
        <meta property="og:locale" content="en_US" />
        <meta property="og:image" content="https://joinmane.com/og-image-v8.png" />
      </Helmet>
      <div style={s.wrap}>
        <div style={s.badge}>Mane vs. Square</div>
        <h1 style={s.h1}>Square wasn't built for you. Mane was.</h1>
        <p style={s.sub}>
          Square is a payment company that added scheduling. Mane is a booking platform
          built from the ground up for beauty and service professionals. There's a difference —
          and you feel it every time you open the app.
        </p>

        <div style={s.sectionTitle}>Side-by-side breakdown</div>
        <table style={s.table}>
          <thead>
            <tr>
              <th style={s.thLabel}></th>
              <th style={s.thMane}>Mane (Founding)</th>
              <th style={s.thComp}>Square Appointments</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r, i) => (
              <tr key={i}>
                <td style={s.tdLabel}>{r.label}</td>
                <td style={s.tdMane}>{r.mane}</td>
                <td style={s.tdComp}>{r.comp}</td>
              </tr>
            ))}
          </tbody>
        </table>

        <div style={s.callout}>
          <div style={s.calloutLabel}>The real cost</div>
          <p style={s.calloutText}>
            Stylist taking 40 appointments/week, average ticket $75.<br />
            Square Plus plan: $69/mo + 2.6% processing on $12,000/mo = <strong style={{ color: RED }}>$69 + $312 = $381/mo.</strong><br />
            Most of that processing fee is unavoidable — but the $69/mo platform fee isn't.<br /><br />
            Mane founding rate: <strong style={{ color: GREEN }}>$29/mo + standard Stripe processing.</strong><br />
            That's <strong style={{ color: GREEN }}>$40/mo saved</strong> on the platform alone — <strong style={{ color: GREEN }}>$480/year</strong> back in your pocket.
          </p>
        </div>

        <div style={s.sectionTitle}>Common questions</div>
        {faqs.map((f, i) => (
          <div key={i} style={s.faqItem}>
            <div style={s.faqQ}>{f.q}</div>
            <p style={s.faqA}>{f.a}</p>
          </div>
        ))}

        <div style={s.cta}>
          <div style={s.ctaTitle}>Use a tool that was built for your craft.</div>
          <p style={s.ctaSub}>
            50 founding spots. Pay $199 once, then $29/mo locked for life.<br />
            When the spots fill, the price goes to $59/mo — no exceptions.
          </p>
          <Link to="/founding" style={s.btn}>Claim Your Founding Spot</Link>
          <p style={{ color: OFF_WHITE, fontSize: 13, marginTop: 20 }}>
            Questions? <a href="mailto:christiangflairbiz@gmail.com" style={{ color: GOLD }}>Email Christian directly.</a> He answers.
          </p>
        </div>
      </div>
    </div>
  );
}
